import { Link } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";

export default function Forbidden() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-brand-dark px-4 text-center text-white">
      <div className="rounded-full bg-red-500/10 p-6 text-red-500 mb-6 border-glow">
        <ShieldAlert className="h-16 w-16" />
      </div>
      <h1 className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl">
        403 - Adgang nægtet
      </h1>
      <p className="mt-4 max-w-md text-sm sm:text-base text-gray-400 leading-relaxed">
        Du har desværre ikke tilladelse til at tilgå denne side. Hvis du mener, dette er en fejl, bedes du kontakte os.
      </p>
      <div className="mt-10">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded bg-brand-accent px-6 py-3 text-xs font-bold uppercase tracking-wider text-white transition-colors hover:bg-brand-accent-hover"
        >
          <ArrowLeft className="h-4 w-4" />
          Tilbage til forsiden
        </Link>
      </div>
    </div>
  );
}
